import { useEditSceneModalStateContext } from './EditSceneModalStateContext';

export default function useIsSaving() {
  const {
    state: { isSaving },
  } = useEditSceneModalStateContext();

  return {
    isSaving,
  };
}
